import React from "react";
import BannerBackground from "../Assets/home-banner-background.png";
import BannerImage from "../Assets/berliettmain.jpg";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";

const sendEmailMain = () => {
  var link = "mailto:berliet_hidraulicos@hotmail.com"
           + "?subject=" + encodeURIComponent("consulta")
           + "&body=hola" 
  ;
  
  window.location.href = link;
}

const Home = () => {
  return (
    <div className="home-container">
      <Navbar />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
        <div className="home-text-section">
          <h1 className="primary-heading">
            Especialistas en Sistemas Hidraulicos
          </h1>
          <p className="primary-text">
            Reparacion, Mantenimiento, Mecanica.  Ofrecemos soluciones a problemas de sistemas hidraulicos.
          </p>
          <div><h1 className="primary-heading">09-86560832</h1><br/><h1 className="primary-heading">09-68475015</h1> <h3 className="secondary-text">berliet_hidraulicos@hotmail.com</h3> <br/></div>
          <button className="secondary-button" onClick={(e) => sendEmailMain()}>
            Contactanos Ahora <FiArrowRight />{" "}
          </button>
        </div>
        <div className="home-image-section">
          <img src={BannerImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Home;
